exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.dddpre[data-v-caf06a7c] {\n    white-space: pre;\n    font-family: pre;\n}\n", ""]);

// exports
